var App = App || {};

App.RatesBand = (function ($) {
    "use strict";

    function init() {

        const ratesBands = $(".widget.widget-rates-band");

        if (ratesBands.length) {
            ratesBands.each(function () {
                const ratesBand = $(this)
                const desktopCards = ratesBand.find(".rate-cards-desktop");
                const realOrder = ratesBand.find(".real-order .card-wrapper");
                const cardCount = realOrder.length;

                var index = 0;

                //mobile slider
                InitCarousels($(this));
                //desktop fader, initial positions
                setCards(ratesBand, realOrder, index, true);

                if (desktopCards.length) {
                    const nextBtn = ratesBand.find(".desktop-ratesband-nav.ratesband-next");
                    const prevBtn = ratesBand.find(".desktop-ratesband-nav.ratesband-prev");

                    nextBtn.on("click", function () {
                        index = (index + 1) % cardCount;
                        setCards(ratesBand, realOrder, index);
                    });

                    prevBtn.on("click", function () {
                        index = (index + cardCount - 1) % cardCount;
                        setCards(ratesBand, realOrder, index);
                    });

                    realOrder.each(function () {
                        setTabindex(this);
                    });
                    $(window).resize(function () {
                        realOrder.each(function () {
                            setTabindex(this);
                        });
                    })

                    setMinHeight(ratesBand);
                    $(window).resize(function () {
                        setMinHeight(ratesBand);
                    })
                }
            });
        }
    }

    function setCards(ratesBand, realOrder, index, initialSetup = false) {
        const desktopCards = ratesBand.find(".rate-cards-desktop");
        const cardCount = realOrder.length;
        const column1 = ratesBand.find(".carousel-col.cc-1 .primary-card")
        const column2 = ratesBand.find(".carousel-col.cc-2");
        const column3 = ratesBand.find(".carousel-col.cc-3");

        if (!initialSetup) {
            realOrder.removeClass("animate__fadeIn");
        }

        column1.empty();
        column1.append(realOrder[index]);

        if (cardCount > 1) {
            column2.empty();
            var next = (index + 1) % cardCount;
            column2.append(realOrder[next]);
        }

        if (cardCount > 2) {
            next = (next + 1) % cardCount;
            column2.append(realOrder[next]);
        }

        if (cardCount > 3) {
            column3.empty();
            next = (next + 1) % cardCount;
            column3.append(realOrder[next]);
        }

        if (!initialSetup) {
            //aesthetic card transition
            desktopCards.find(".card-wrapper").each(function (index) {
                setTabindex(this);
                var thisCard = $(this);
                thisCard.removeClass("opaque");
                setTimeout(function () {
                    thisCard.addClass("opaque");
                }, 0 + (111 * index));
            });
        }
    }

    function setTabindex(element) {
        //offscreen cards should not be tab accessible
        var thisLink = $(element).find("a");

        if (element.getBoundingClientRect().right >= window.innerWidth || element.getBoundingClientRect().right >= document.documentElement.clientWidth) {
            thisLink.attr("tabindex", -1);
        } else {
            thisLink.attr("tabindex", 0);
        }
    }

    function setMinHeight(ratesBand) {
        var cards = ratesBand.find(".card-wrapper");
        var maxHeight = 0;
        cards.each(function () {
            if ($(this).outerHeight() > maxHeight) {
                maxHeight = $(this).outerHeight();
            }
        });

        ratesBand.find(".carousel-col.cc-2").css("min-height", ((maxHeight * 2) + 30));
    }

    function InitCarousels(ratesBand) {
        const carousel = ratesBand.find(".splide");
        if (carousel.length) {
            const splideCarousel = new Splide(carousel[0], {
                pagination: false,
                type: 'loop',
                focus: 'center',
                fixedWidth: "250px",
                gap: "10px",
                drag: true,
                snap: false,
                perMove: 1
                
            });

            splideCarousel.mount();

            const nextBtn = ratesBand.find(".carousel-btn.carousel-next");
            const prevBtn = ratesBand.find(".carousel-btn.carousel-prev");

            nextBtn.on("click", function () {
                splideCarousel.go('+1')
            });

            prevBtn.on("click", function () {
                splideCarousel.go('-1')
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.RatesBand.init();
});